import { AI_ADVANCED_MODE_MIN_DOCUMENT_CHARS } from '../constants';

const isCostlyAiDocument = (html: string | undefined): boolean =>
  (html?.length ?? 0) >= AI_ADVANCED_MODE_MIN_DOCUMENT_CHARS;

export default isCostlyAiDocument;
